import React from 'react';
import logo from '../assets/innovarxi-logo.svg';

// Full-page start-up screen shown while Auth0 checks the session. To remove it, render the
// old <Spinner /> in App.tsx instead and delete this file plus the .splash rules.
const SplashScreen: React.FC<{ message?: string }> = ({
  message = 'Checking your session…',
}) => (
  <div className="splash" role="status" aria-live="polite">
    <img src={logo} alt="innovaRXI. Innovating Your Vision Into Reality" />
    <div className="splash-bar" aria-hidden="true">
      <i />
    </div>
    <div className="splash-text">{message}</div>
  </div>
);

export default SplashScreen;
